import React from 'react';
import { CONFIG } from '../../config/config';
import './TopBanner.css';

const TopBanner = () => {
  if (!CONFIG.PRELAUNCH.ENABLED || !CONFIG.UI.SHOW_TOP_BANNER) return null;

  return (
    <div className="top-banner" role="banner">
      <p className="top-banner-text">{CONFIG.UI.TOP_BANNER_TEXT}</p>
    </div>
  );
};

export default TopBanner;
